<!--公告及新闻稿-->
<template>
  <!--内容-->
  <div class="content_width_box">
    <div class="content_title">
      <div class="title_left_h2">财务报告</div>
      <div class="title_right_tab">
        <div class="tab1" @click="clickTab('年度报告')">年度报告</div>
        <div class="tab2" @click="clickTab('季度报告和其他')">季度报告和其他</div>
      </div>
    </div>
    <div class="select_box">
      <multiselect v-show="selectedItem == '年度报告'" v-model="yearSelected" 
        :options="['全部年份',...this.finYearsReportList.yearList]" 
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
        <multiselect v-show="selectedItem == '季度报告和其他'" v-model="yearOtherSelected" 
        :options="['全部年份',...this.quarterReportList.yearList]" 
        :searchable="false" :close-on-select="true" :show-labels="false" placeholder="选择年份"></multiselect>
    </div>
    <YearsTitleListView v-show="selectedItem == '年度报告'" :messageList="finYearsReportList.list" :perPage="finYearsReportList.perPage" detailRouter="invstorDetail" :yearSelected="yearSelected"></YearsTitleListView>
    <YearsTitleListView v-show="selectedItem == '季度报告和其他'" :messageList="quarterReportList.list" :perPage="quarterReportList.perPage" detailRouter="invstorDetail" :yearSelected="yearOtherSelected"></YearsTitleListView>
  </div>  
</template>
<script>

import YearsTitleListView from '../../titleNews/YearsTitleListView'
import UtilEvent from '../../utils/UtilEvent.js'
  export default {
    name: 'investorFinReport',
    components:{UtilEvent,YearsTitleListView},
    props: ['finYearsReportList',],
    created(){
        
    },
    data () {
      return {
        selectedItem:'年度报告',
        yearSelected:'全部年份',
        yearOtherSelected:'全部年份',
        quarterReportList:{total:0,perPage:1,yearList:[],list:[]}
      }
    },
    computed:{
      
    },
    methods:{
      clickTab(item){
        debugger
        this.selectedItem = item;
        if(item == '季度报告和其他' && this.quarterReportList.list && this.quarterReportList.list.length == 0){
          new UtilEvent().getFinQuarterReportListData(this)
        }
      }
      
    },
    watch:{
      
    },
    mounted(){
      
    },
   
  }
  </script>

